import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CloseIcon from "@mui/icons-material/Close";
import { usePushNotifications } from "../../hooks/usePushNotifications";

const DISMISSED_KEY = "push_banner_dismissed";

const useStyles = makeStyles(() => ({
  message: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  icon: {
    color: "#facc15",
  },
}));

export default function PushNotificationBanner() {
  const classes = useStyles();
  const { supported, permission, subscribed, requestAndSubscribe } = usePushNotifications();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!supported) return;
    if (permission === "granted" && subscribed) return;
    if (permission === "denied") return;
    const dismissed = localStorage.getItem(DISMISSED_KEY);
    if (dismissed) return;
    // Espera 3s após carregar para não atrapalhar o fluxo inicial
    const t = setTimeout(() => setOpen(true), 3000);
    return () => clearTimeout(t);
  }, [supported, permission, subscribed]);

  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, "1");
    setOpen(false);
  };

  const handleAllow = async () => {
    setLoading(true);
    const result = await requestAndSubscribe();
    setLoading(false);
    if (result === "denied") {
      localStorage.setItem(DISMISSED_KEY, "1");
    }
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      message={
        <span className={classes.message}>
          <NotificationsIcon className={classes.icon} fontSize="small" />
          Ativar notificações para receber avisos mesmo com o app fechado?
        </span>
      }
      action={
        <>
          <Button
            color="secondary"
            size="small"
            onClick={handleAllow}
            disabled={loading}
            style={{ fontWeight: 700 }}
          >
            {loading ? "Ativando..." : "Ativar"}
          </Button>
          <IconButton size="small" color="inherit" onClick={handleDismiss}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    />
  );
}
